// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-contents {
  padding: 16px 30px;
  display: flex;
  justify-content: space-between;
  background: #fff;
}
.header-contents .logo,
.header-contents .logo a {
  display: flex;
  justify-content: center;
}
.header-contents .logo img {
  width: 100%;
}
.user-info {
  position: relative;
}
.user-info .user-info-wrapper {
  display: flex;
  align-items: center;
}
.user-info .user-name {
  margin-right: 14px;
  font-size: 16px;
}

.logout-modal-component {
  background: #fff;
  border-radius: 8px;
  padding: 20px 50px;
  text-align: left;
  position: absolute;
  right: 0;
  top: 67px;
  cursor: pointer;
  z-index: 99;
}

.logout-modal-heading {
  font-size: 14px;
  font-weight: 500;
}
.user-name-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  height: 47px;
  width: 47px;
  font-weight: 600;
  background-color: #1883bb;
  color: #ffffff;
  border-radius: 100%;
  cursor: pointer;
}
.applicationUpload-userInfo--wrapper {
  display: flex;
  align-items: center;
}
.applicationUpload--btn {
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  padding: 0px 20px;
  height: 36px;
  line-height: 36px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".header-contents {\n  padding: 16px 30px;\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n}\n.header-contents .logo,\n.header-contents .logo a {\n  display: flex;\n  justify-content: center;\n}\n.header-contents .logo img {\n  width: 100%;\n}\n.user-info {\n  position: relative;\n}\n.user-info .user-info-wrapper {\n  display: flex;\n  align-items: center;\n}\n.user-info .user-name {\n  margin-right: 14px;\n  font-size: 16px;\n}\n\n.logout-modal-component {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px 50px;\n  text-align: left;\n  position: absolute;\n  right: 0;\n  top: 67px;\n  cursor: pointer;\n  z-index: 99;\n}\n\n.logout-modal-heading {\n  font-size: 14px;\n  font-weight: 500;\n}\n.user-name-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  height: 47px;\n  width: 47px;\n  font-weight: 600;\n  background-color: #1883bb;\n  color: #ffffff;\n  border-radius: 100%;\n  cursor: pointer;\n}\n.applicationUpload-userInfo--wrapper {\n  display: flex;\n  align-items: center;\n}\n.applicationUpload--btn {\n  display: inline-block;\n  margin-right: 20px;\n  font-size: 14px;\n  padding: 0px 20px;\n  height: 36px;\n  line-height: 36px;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
